














// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

// Components
import ProductCard from '@/clickbuy/purchase/views/product-card.view.vue';


@Component({
    components: {
        ProductCard,
    },
    computed: {
        ...mapGetters({
            currentPurchase: 'getCurrentPurchase',
            hasClient: 'currentPurchaseHasClient',
            purchaseFinished: 'currentPurchaseFinished',
            hasPreviousPurchases: 'hasPurchases',
            previousPurchaseIsCanceled: 'previousPurchaseIsCanceled',
        }),
    },
})
export default class ProductBranch extends Vue {
    @Prop() private productList!: any[];
    @Prop({ default: false }) private decoration!: boolean;


    private currentPurchase!: any;
    private hasClient!: any;
    private hasPreviousPurchases!: any;
    private purchaseFinished!: any;
    private previousPurchaseIsCanceled!: boolean;


    get cardDisabled() {
        return (
            !this.hasClient ||
            (
                this.hasPreviousPurchases &&
                !this.previousPurchaseIsCanceled &&
                !this.currentPurchase.addNewPurchase
            ) ||
            this.purchaseFinished
        );
    }
}

